// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteAppsByIdData, DeleteAppsByIdEnvironmentsByEnvIdData, DeleteAppsByIdEnvironmentsByEnvIdErrors, DeleteAppsByIdEnvironmentsByEnvIdResponses, DeleteAppsByIdErrors, DeleteAppsByIdMembersByUserIdData, DeleteAppsByIdMembersByUserIdResponses, DeleteAppsByIdReleasesByReleaseIdData, DeleteAppsByIdReleasesByReleaseIdErrors, DeleteAppsByIdReleasesByReleaseIdResponses, DeleteAppsByIdResponses, DeleteAuthSessionsByIdData, DeleteAuthSessionsByIdErrors, DeleteAuthSessionsByIdResponses, DeleteBackupRestorePendingData, DeleteBackupRestorePendingErrors, DeleteBackupRestorePendingResponses, DeleteCyclesByIdData, DeleteCyclesByIdErrors, DeleteCyclesByIdResponses, DeleteInvitesByIdData, DeleteInvitesByIdResponses, DeleteLabelsByIdData, DeleteLabelsByIdErrors, DeleteLabelsByIdResponses, DeleteOrganizationData, DeleteOrganizationErrors, DeleteOrganizationResponses, DeleteProjectsByIdCustomFieldsByFieldIdData, DeleteProjectsByIdCustomFieldsByFieldIdResponses, DeleteProjectsByIdData, DeleteProjectsByIdErrors, DeleteProjectsByIdResponses, DeleteProjectsByIdStatusesByStatusIdData, DeleteProjectsByIdStatusesByStatusIdErrors, DeleteProjectsByIdStatusesByStatusIdResponses, DeleteProjectsByIdStoriesByStoryIdAttachmentsByAttachmentIdData, DeleteProjectsByIdStoriesByStoryIdAttachmentsByAttachmentIdResponses, DeleteProjectsByIdStoriesByStoryIdData, DeleteProjectsByIdStoriesByStoryIdErrors, DeleteProjectsByIdStoriesByStoryIdResponses, DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsByAttachmentIdData, DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsByAttachmentIdResponses, DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsData, DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsResponses, DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdData, DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdResponses, DeleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentIdData, DeleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentIdErrors, DeleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentIdResponses, DeleteProjectsByIdTasksByTaskIdCommentsByCommentIdData, DeleteProjectsByIdTasksByTaskIdCommentsByCommentIdErrors, DeleteProjectsByIdTasksByTaskIdCommentsByCommentIdResponses, DeleteProjectsByIdTasksByTaskIdData, DeleteProjectsByIdTasksByTaskIdDependenciesByBlocksTaskIdData, DeleteProjectsByIdTasksByTaskIdDependenciesByBlocksTaskIdResponses, DeleteProjectsByIdTasksByTaskIdResponses, DeleteProjectsByIdTasksByTaskIdTimeEntriesByEntryIdData, DeleteProjectsByIdTasksByTaskIdTimeEntriesByEntryIdErrors, DeleteProjectsByIdTasksByTaskIdTimeEntriesByEntryIdResponses, DeleteProjectsByIdTemplatesByTemplateIdData, DeleteProjectsByIdTemplatesByTemplateIdResponses, DeletePushSubscribeData, DeletePushSubscribeErrors, DeletePushSubscribeResponses, GetApiVersionData, GetApiVersionResponses, GetApprovalsCountData, GetApprovalsCountResponses, GetApprovalsData, GetApprovalsResponses, GetAppsByIdData, GetAppsByIdDeploymentsByDeploymentIdData, GetAppsByIdDeploymentsByDeploymentIdErrors, GetAppsByIdDeploymentsByDeploymentIdResponses, GetAppsByIdDeploymentsData, GetAppsByIdDeploymentsResponses, GetAppsByIdEnvironmentsData, GetAppsByIdEnvironmentsResponses, GetAppsByIdErrors, GetAppsByIdMembersData, GetAppsByIdMembersErrors, GetAppsByIdMembersResponses, GetAppsByIdMyAccessData, GetAppsByIdMyAccessResponses, GetAppsByIdReleasesByReleaseIdCandidatesData, GetAppsByIdReleasesByReleaseIdCandidatesResponses, GetAppsByIdReleasesByReleaseIdData, GetAppsByIdReleasesByReleaseIdErrors, GetAppsByIdReleasesByReleaseIdResponses, GetAppsByIdReleasesByReleaseIdTasksData, GetAppsByIdReleasesByReleaseIdTasksResponses, GetAppsByIdReleasesData, GetAppsByIdReleasesResponses, GetAppsByIdResponses, GetAppsBySlugBySlugData, GetAppsBySlugBySlugErrors, GetAppsBySlugBySlugResponses, GetAppsData, GetAppsResponses, GetAttachmentsByAttachmentIdDownloadData, GetAttachmentsByAttachmentIdDownloadErrors, GetAttachmentsByAttachmentIdDownloadResponses, GetAttachmentsByAttachmentIdUrlData, GetAttachmentsByAttachmentIdUrlErrors, GetAttachmentsByAttachmentIdUrlResponses, GetAuditLogData, GetAuditLogResponses, GetAuthMeData, GetAuthMeErrors, GetAuthMeResponses, GetAuthSessionsData, GetAuthSessionsResponses, GetAvatarsByIdData, GetAvatarsByIdErrors, GetAvatarsByIdResponses, GetBackupDownloadData, GetBackupDownloadErrors, GetBackupDownloadResponses, GetBackupRestorePendingData, GetBackupRestorePendingResponses, GetBusinessOwnersData, GetBusinessOwnersResponses, GetCyclesData, GetCyclesResponses, GetDashboardData, GetDashboardErrors, GetDashboardKanbanData, GetDashboardKanbanErrors, GetDashboardKanbanResponses, GetDashboardResponses, GetHealthzData, GetHealthzErrors, GetHealthzResponses, GetInvitesByTokenValidateData, GetInvitesByTokenValidateErrors, GetInvitesByTokenValidateResponses, GetInvitesData, GetInvitesResponses, GetLabelsData, GetLabelsResponses, GetMentionsSearchData, GetMentionsSearchErrors, GetMentionsSearchResponses, GetNotificationsData, GetNotificationsErrors, GetNotificationsResponses, GetNotificationsUnreadCountData, GetNotificationsUnreadCountErrors, GetNotificationsUnreadCountResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, GetPortfolioProjectsData, GetPortfolioProjectsErrors, GetPortfolioProjectsResponses, GetProjectsByIdCustomFieldsData, GetProjectsByIdCustomFieldsResponses, GetProjectsByIdData, GetProjectsByIdErrors, GetProjectsByIdMembersData, GetProjectsByIdMembersResponses, GetProjectsByIdMyAccessData, GetProjectsByIdMyAccessErrors, GetProjectsByIdMyAccessResponses, GetProjectsByIdReleasesData, GetProjectsByIdReleasesResponses, GetProjectsByIdResponses, GetProjectsByIdStatusesData, GetProjectsByIdStatusesResponses, GetProjectsByIdStoriesByStoryIdAttachmentsData, GetProjectsByIdStoriesByStoryIdAttachmentsResponses, GetProjectsByIdStoriesByStoryIdData, GetProjectsByIdStoriesByStoryIdErrors, GetProjectsByIdStoriesByStoryIdResponses, GetProjectsByIdStoriesByStoryIdTestCasesData, GetProjectsByIdStoriesByStoryIdTestCasesResponses, GetProjectsByIdStoriesData, GetProjectsByIdStoriesResponses, GetProjectsByIdTasksByTaskIdActivityData, GetProjectsByIdTasksByTaskIdActivityErrors, GetProjectsByIdTasksByTaskIdActivityResponses, GetProjectsByIdTasksByTaskIdAttachmentsData, GetProjectsByIdTasksByTaskIdAttachmentsResponses, GetProjectsByIdTasksByTaskIdCommentsData, GetProjectsByIdTasksByTaskIdCommentsResponses, GetProjectsByIdTasksByTaskIdCustomFieldsData, GetProjectsByIdTasksByTaskIdCustomFieldsResponses, GetProjectsByIdTasksByTaskIdData, GetProjectsByIdTasksByTaskIdDependenciesBlockedData, GetProjectsByIdTasksByTaskIdDependenciesBlockedResponses, GetProjectsByIdTasksByTaskIdDependenciesBlockingData, GetProjectsByIdTasksByTaskIdDependenciesBlockingResponses, GetProjectsByIdTasksByTaskIdDeploymentsData, GetProjectsByIdTasksByTaskIdDeploymentsResponses, GetProjectsByIdTasksByTaskIdErrors, GetProjectsByIdTasksByTaskIdLabelsData, GetProjectsByIdTasksByTaskIdLabelsResponses, GetProjectsByIdTasksByTaskIdResponses, GetProjectsByIdTasksByTaskIdSubtasksData, GetProjectsByIdTasksByTaskIdSubtasksErrors, GetProjectsByIdTasksByTaskIdSubtasksResponses, GetProjectsByIdTasksByTaskIdTimeEntriesData, GetProjectsByIdTasksByTaskIdTimeEntriesResponses, GetProjectsByIdTasksData, GetProjectsByIdTasksExportData, GetProjectsByIdTasksExportResponses, GetProjectsByIdTasksResponses, GetProjectsByIdTemplatesData, GetProjectsByIdTemplatesResponses, GetProjectsByIdTimeEntriesExportData, GetProjectsByIdTimeEntriesExportResponses, GetProjectsBySlugBySlugData, GetProjectsBySlugBySlugErrors, GetProjectsBySlugBySlugResponses, GetProjectsData, GetProjectsResponses, GetPushVapidPublicKeyData, GetPushVapidPublicKeyResponses, GetSearchData, GetSearchErrors, GetSearchResponses, GetSettingsNotificationsData, GetSettingsNotificationsErrors, GetSettingsNotificationsResponses, GetSettingsPreferencesData, GetSettingsPreferencesErrors, GetSettingsPreferencesResponses, GetSetupData, GetSetupResponses, GetSprintDashboardContextData, GetSprintDashboardContextErrors, GetSprintDashboardContextResponses, GetSprintDashboardMeData, GetSprintDashboardMeErrors, GetSprintDashboardMeResponses, GetSprintDashboardOverviewData, GetSprintDashboardOverviewErrors, GetSprintDashboardOverviewResponses, GetSprintDashboardProjectsData, GetSprintDashboardProjectsErrors, GetSprintDashboardProjectsResponses, GetSprintDashboardQualityData, GetSprintDashboardQualityErrors, GetSprintDashboardQualityResponses, GetSprintDashboardTeamData, GetSprintDashboardTeamErrors, GetSprintDashboardTeamResponses, GetStoriesData, GetStoriesErrors, GetStoriesResponses, GetStoryAttachmentsByAttachmentIdDownloadData, GetStoryAttachmentsByAttachmentIdDownloadErrors, GetStoryAttachmentsByAttachmentIdDownloadResponses, GetTasksData, GetTasksResponses, GetTestCaseAttachmentsByAttachmentIdDownloadData, GetTestCaseAttachmentsByAttachmentIdDownloadErrors, GetTestCaseAttachmentsByAttachmentIdDownloadResponses, GetUsersByIdAppMembershipsData, GetUsersByIdAppMembershipsErrors, GetUsersByIdAppMembershipsResponses, GetUsersByIdData, GetUsersByIdErrors, GetUsersByIdResponses, GetUsersData, GetUsersResponses, GetWorkspacesData, GetWorkspacesErrors, GetWorkspacesResponses, GetWsData, PatchAccountData, PatchAccountErrors, PatchAccountResponses, PatchAppsByIdDeploymentsByDeploymentIdData, PatchAppsByIdDeploymentsByDeploymentIdResponses, PatchDashboardVisibilityData, PatchDashboardVisibilityErrors, PatchDashboardVisibilityResponses, PatchLabelsByIdData, PatchLabelsByIdErrors, PatchLabelsByIdResponses, PatchNotificationsByIdReadData, PatchNotificationsByIdReadErrors, PatchNotificationsByIdReadResponses, PatchNotificationsReadAllData, PatchNotificationsReadAllErrors, PatchNotificationsReadAllResponses, PatchOrganizationData, PatchOrganizationErrors, PatchOrganizationResponses, PatchProjectsByIdCustomFieldsByFieldIdData, PatchProjectsByIdCustomFieldsByFieldIdResponses, PatchProjectsByIdTasksByTaskIdCommentsByCommentIdData, PatchProjectsByIdTasksByTaskIdCommentsByCommentIdErrors, PatchProjectsByIdTasksByTaskIdCommentsByCommentIdResponses, PatchProjectsByIdTasksByTaskIdPositionData, PatchProjectsByIdTasksByTaskIdPositionErrors, PatchProjectsByIdTasksByTaskIdPositionResponses, PatchProjectsByIdTemplatesByTemplateIdData, PatchProjectsByIdTemplatesByTemplateIdResponses, PatchSettingsNotificationsByTypeData, PatchSettingsNotificationsByTypeErrors, PatchSettingsNotificationsByTypeResponses, PatchSettingsPreferencesData, PatchSettingsPreferencesErrors, PatchSettingsPreferencesResponses, PostAccountAvatarData, PostAccountAvatarErrors, PostAccountAvatarResponses, PostAppsByIdDeploymentsByDeploymentIdApproveData, PostAppsByIdDeploymentsByDeploymentIdApproveErrors, PostAppsByIdDeploymentsByDeploymentIdApproveResponses, PostAppsByIdDeploymentsByDeploymentIdCancelData, PostAppsByIdDeploymentsByDeploymentIdCancelResponses, PostAppsByIdDeploymentsByDeploymentIdDeployData, PostAppsByIdDeploymentsByDeploymentIdDeployResponses, PostAppsByIdDeploymentsByDeploymentIdRejectData, PostAppsByIdDeploymentsByDeploymentIdRejectResponses, PostAppsByIdDeploymentsByDeploymentIdResubmitData, PostAppsByIdDeploymentsByDeploymentIdResubmitResponses, PostAppsByIdDeploymentsByDeploymentIdRollbackData, PostAppsByIdDeploymentsByDeploymentIdRollbackResponses, PostAppsByIdDeploymentsData, PostAppsByIdDeploymentsErrors, PostAppsByIdDeploymentsResponses, PostAppsByIdEnvironmentsData, PostAppsByIdEnvironmentsResponses, PostAppsByIdMembersData, PostAppsByIdMembersErrors, PostAppsByIdMembersResponses, PostAppsByIdProjectsData, PostAppsByIdProjectsErrors, PostAppsByIdProjectsResponses, PostAppsByIdReleasesByReleaseIdTasksData, PostAppsByIdReleasesByReleaseIdTasksErrors, PostAppsByIdReleasesByReleaseIdTasksRemoveData, PostAppsByIdReleasesByReleaseIdTasksRemoveResponses, PostAppsByIdReleasesByReleaseIdTasksResponses, PostAppsByIdReleasesData, PostAppsByIdReleasesErrors, PostAppsByIdReleasesResponses, PostAppsData, PostAppsErrors, PostAppsResponses, PostAuthLogoutData, PostAuthLogoutResponses, PostAuthMagicLinkData, PostAuthMagicLinkResponses, PostAuthMagicLinkVerifyData, PostAuthMagicLinkVerifyErrors, PostAuthMagicLinkVerifyResponses, PostBackupRestoreData, PostBackupRestoreErrors, PostBackupRestoreResponses, PostCyclesByIdActivateData, PostCyclesByIdActivateErrors, PostCyclesByIdActivateResponses, PostCyclesByIdCompleteData, PostCyclesByIdCompleteErrors, PostCyclesByIdCompleteResponses, PostCyclesData, PostCyclesErrors, PostCyclesResponses, PostInvitesByTokenAcceptData, PostInvitesByTokenAcceptErrors, PostInvitesByTokenAcceptResponses, PostInvitesData, PostInvitesErrors, PostInvitesResponses, PostLabelsData, PostLabelsErrors, PostLabelsResponses, PostProjectsByIdArchiveData, PostProjectsByIdArchiveErrors, PostProjectsByIdArchiveResponses, PostProjectsByIdCustomFieldsData, PostProjectsByIdCustomFieldsResponses, PostProjectsByIdStatusesData, PostProjectsByIdStatusesErrors, PostProjectsByIdStatusesResponses, PostProjectsByIdStoriesByStoryIdAttachmentsData, PostProjectsByIdStoriesByStoryIdAttachmentsResponses, PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsData, PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsResponses, PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsData, PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsResponses, PostProjectsByIdStoriesByStoryIdTestCasesData, PostProjectsByIdStoriesByStoryIdTestCasesResponses, PostProjectsByIdStoriesData, PostProjectsByIdStoriesErrors, PostProjectsByIdStoriesResponses, PostProjectsByIdTasksBatchData, PostProjectsByIdTasksBatchErrors, PostProjectsByIdTasksBatchResponses, PostProjectsByIdTasksByTaskIdAttachmentsData, PostProjectsByIdTasksByTaskIdAttachmentsErrors, PostProjectsByIdTasksByTaskIdAttachmentsResponses, PostProjectsByIdTasksByTaskIdCommentsData, PostProjectsByIdTasksByTaskIdCommentsErrors, PostProjectsByIdTasksByTaskIdCommentsResponses, PostProjectsByIdTasksByTaskIdDependenciesData, PostProjectsByIdTasksByTaskIdDependenciesErrors, PostProjectsByIdTasksByTaskIdDependenciesResponses, PostProjectsByIdTasksByTaskIdDuplicateData, PostProjectsByIdTasksByTaskIdDuplicateErrors, PostProjectsByIdTasksByTaskIdDuplicateResponses, PostProjectsByIdTasksByTaskIdMoveData, PostProjectsByIdTasksByTaskIdMoveErrors, PostProjectsByIdTasksByTaskIdMoveResponses, PostProjectsByIdTasksByTaskIdSubtasksReorderData, PostProjectsByIdTasksByTaskIdSubtasksReorderErrors, PostProjectsByIdTasksByTaskIdSubtasksReorderResponses, PostProjectsByIdTasksByTaskIdTimeEntriesData, PostProjectsByIdTasksByTaskIdTimeEntriesErrors, PostProjectsByIdTasksByTaskIdTimeEntriesResponses, PostProjectsByIdTasksByTaskIdTimeEntriesStartData, PostProjectsByIdTasksByTaskIdTimeEntriesStartErrors, PostProjectsByIdTasksByTaskIdTimeEntriesStartResponses, PostProjectsByIdTasksByTaskIdTimeEntriesStopData, PostProjectsByIdTasksByTaskIdTimeEntriesStopErrors, PostProjectsByIdTasksByTaskIdTimeEntriesStopResponses, PostProjectsByIdTasksData, PostProjectsByIdTasksErrors, PostProjectsByIdTasksReorderData, PostProjectsByIdTasksReorderErrors, PostProjectsByIdTasksReorderResponses, PostProjectsByIdTasksResponses, PostProjectsByIdTemplatesByTemplateIdInstantiateData, PostProjectsByIdTemplatesByTemplateIdInstantiateResponses, PostProjectsByIdTemplatesData, PostProjectsByIdTemplatesErrors, PostProjectsByIdTemplatesResponses, PostProjectsByIdUnarchiveData, PostProjectsByIdUnarchiveErrors, PostProjectsByIdUnarchiveResponses, PostPushSubscribeData, PostPushSubscribeErrors, PostPushSubscribeResponses, PostWorkspacesByIdSwitchData, PostWorkspacesByIdSwitchErrors, PostWorkspacesByIdSwitchResponses, PostWorkspacesData, PostWorkspacesErrors, PostWorkspacesResponses, PutAppsByIdData, PutAppsByIdEnvironmentsByEnvIdApproversData, PutAppsByIdEnvironmentsByEnvIdApproversResponses, PutAppsByIdEnvironmentsByEnvIdData, PutAppsByIdEnvironmentsByEnvIdResponses, PutAppsByIdErrors, PutAppsByIdMembersByUserIdData, PutAppsByIdMembersByUserIdResponses, PutAppsByIdReleasesByReleaseIdData, PutAppsByIdReleasesByReleaseIdErrors, PutAppsByIdReleasesByReleaseIdResponses, PutAppsByIdResponses, PutCyclesByIdData, PutCyclesByIdErrors, PutCyclesByIdResponses, PutProjectsByIdData, PutProjectsByIdErrors, PutProjectsByIdMembersByUserIdWorkRoleData, PutProjectsByIdMembersByUserIdWorkRoleErrors, PutProjectsByIdMembersByUserIdWorkRoleResponses, PutProjectsByIdMembersWorkRoleData, PutProjectsByIdMembersWorkRoleErrors, PutProjectsByIdMembersWorkRoleResponses, PutProjectsByIdResponses, PutProjectsByIdStatusesByStatusIdData, PutProjectsByIdStatusesByStatusIdErrors, PutProjectsByIdStatusesByStatusIdResponses, PutProjectsByIdStoriesByStoryIdData, PutProjectsByIdStoriesByStoryIdErrors, PutProjectsByIdStoriesByStoryIdMembersData, PutProjectsByIdStoriesByStoryIdMembersErrors, PutProjectsByIdStoriesByStoryIdMembersResponses, PutProjectsByIdStoriesByStoryIdResponses, PutProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdData, PutProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdResponses, PutProjectsByIdTasksByTaskIdCustomFieldsByFieldIdData, PutProjectsByIdTasksByTaskIdCustomFieldsByFieldIdResponses, PutProjectsByIdTasksByTaskIdData, PutProjectsByIdTasksByTaskIdErrors, PutProjectsByIdTasksByTaskIdLabelsData, PutProjectsByIdTasksByTaskIdLabelsResponses, PutProjectsByIdTasksByTaskIdReleaseData, PutProjectsByIdTasksByTaskIdReleaseResponses, PutProjectsByIdTasksByTaskIdResponses, PutProjectsByIdTasksByTaskIdTimeEntriesByEntryIdData, PutProjectsByIdTasksByTaskIdTimeEntriesByEntryIdErrors, PutProjectsByIdTasksByTaskIdTimeEntriesByEntryIdResponses, PutUsersByIdActiveData, PutUsersByIdActiveErrors, PutUsersByIdActiveResponses, PutUsersByIdAppMembershipsData, PutUsersByIdAppMembershipsErrors, PutUsersByIdAppMembershipsResponses, PutUsersByIdBusinessOwnerData, PutUsersByIdBusinessOwnerErrors, PutUsersByIdBusinessOwnerResponses, PutUsersByIdRoleData, PutUsersByIdRoleErrors, PutUsersByIdRoleResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Update own profile
 *
 * Changes the caller's display name (synced across all workspaces)
 */
export const patchAccount = <ThrowOnError extends boolean = false>(options: Options<PatchAccountData, ThrowOnError>): RequestResult<PatchAccountResponses, PatchAccountErrors, ThrowOnError> => (options.client ?? client).patch<PatchAccountResponses, PatchAccountErrors, ThrowOnError>({
    url: '/account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload avatar
 *
 * Uploads an avatar image for the caller's account (synced across all workspaces)
 */
export const postAccountAvatar = <ThrowOnError extends boolean = false>(options: Options<PostAccountAvatarData, ThrowOnError>): RequestResult<PostAccountAvatarResponses, PostAccountAvatarErrors, ThrowOnError> => (options.client ?? client).post<PostAccountAvatarResponses, PostAccountAvatarErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/account/avatar',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Version
 *
 * Returns the running build version
 */
export const getApiVersion = <ThrowOnError extends boolean = false>(options?: Options<GetApiVersionData, ThrowOnError>): RequestResult<GetApiVersionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiVersionResponses, unknown, ThrowOnError>({ url: '/api/version', ...options });

/**
 * My pending approvals
 *
 * Deployment requests awaiting the caller's approval, across all apps
 */
export const getApprovals = <ThrowOnError extends boolean = false>(options?: Options<GetApprovalsData, ThrowOnError>): RequestResult<GetApprovalsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApprovalsResponses, unknown, ThrowOnError>({ url: '/approvals', ...options });

/**
 * Pending approval count
 */
export const getApprovalsCount = <ThrowOnError extends boolean = false>(options?: Options<GetApprovalsCountData, ThrowOnError>): RequestResult<GetApprovalsCountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApprovalsCountResponses, unknown, ThrowOnError>({ url: '/approvals/count', ...options });

/**
 * List apps
 *
 * Returns the apps visible to the authenticated user, including their projects.
 */
export const getApps = <ThrowOnError extends boolean = false>(options?: Options<GetAppsData, ThrowOnError>): RequestResult<GetAppsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAppsResponses, unknown, ThrowOnError>({ url: '/apps', ...options });

/**
 * Create an app
 *
 * Creates an app grouping for projects in the organization.
 */
export const postApps = <ThrowOnError extends boolean = false>(options: Options<PostAppsData, ThrowOnError>): RequestResult<PostAppsResponses, PostAppsErrors, ThrowOnError> => (options.client ?? client).post<PostAppsResponses, PostAppsErrors, ThrowOnError>({
    url: '/apps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an app by slug
 *
 * Returns an app and its visible projects by slug.
 */
export const getAppsBySlugBySlug = <ThrowOnError extends boolean = false>(options: Options<GetAppsBySlugBySlugData, ThrowOnError>): RequestResult<GetAppsBySlugBySlugResponses, GetAppsBySlugBySlugErrors, ThrowOnError> => (options.client ?? client).get<GetAppsBySlugBySlugResponses, GetAppsBySlugBySlugErrors, ThrowOnError>({ url: '/apps/by-slug/{slug}', ...options });

/**
 * Delete an app
 *
 * Deletes an app and leaves its projects available as standalone projects.
 */
export const deleteAppsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAppsByIdData, ThrowOnError>): RequestResult<DeleteAppsByIdResponses, DeleteAppsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAppsByIdResponses, DeleteAppsByIdErrors, ThrowOnError>({ url: '/apps/{id}', ...options });

/**
 * Get an app
 *
 * Returns an app and its visible projects by ID.
 */
export const getAppsById = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdData, ThrowOnError>): RequestResult<GetAppsByIdResponses, GetAppsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetAppsByIdResponses, GetAppsByIdErrors, ThrowOnError>({ url: '/apps/{id}', ...options });

/**
 * Update an app
 *
 * Updates app metadata without changing its projects.
 */
export const putAppsById = <ThrowOnError extends boolean = false>(options: Options<PutAppsByIdData, ThrowOnError>): RequestResult<PutAppsByIdResponses, PutAppsByIdErrors, ThrowOnError> => (options.client ?? client).put<PutAppsByIdResponses, PutAppsByIdErrors, ThrowOnError>({
    url: '/apps/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List deployments
 */
export const getAppsByIdDeployments = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdDeploymentsData, ThrowOnError>): RequestResult<GetAppsByIdDeploymentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAppsByIdDeploymentsResponses, unknown, ThrowOnError>({ url: '/apps/{id}/deployments', ...options });

/**
 * Request a deployment
 *
 * Environments that need approval start pending and notify their approvers; others are approved at once
 */
export const postAppsByIdDeployments = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdDeploymentsData, ThrowOnError>): RequestResult<PostAppsByIdDeploymentsResponses, PostAppsByIdDeploymentsErrors, ThrowOnError> => (options.client ?? client).post<PostAppsByIdDeploymentsResponses, PostAppsByIdDeploymentsErrors, ThrowOnError>({
    url: '/apps/{id}/deployments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a deployment
 *
 * Includes the manifest, the event timeline and (for open requests) the promotion gate
 */
export const getAppsByIdDeploymentsByDeploymentId = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdDeploymentsByDeploymentIdData, ThrowOnError>): RequestResult<GetAppsByIdDeploymentsByDeploymentIdResponses, GetAppsByIdDeploymentsByDeploymentIdErrors, ThrowOnError> => (options.client ?? client).get<GetAppsByIdDeploymentsByDeploymentIdResponses, GetAppsByIdDeploymentsByDeploymentIdErrors, ThrowOnError>({ url: '/apps/{id}/deployments/{deploymentId}', ...options });

/**
 * Edit a deployment request
 *
 * Only pending or rejected requests can be edited; each edit bumps the revision
 */
export const patchAppsByIdDeploymentsByDeploymentId = <ThrowOnError extends boolean = false>(options: Options<PatchAppsByIdDeploymentsByDeploymentIdData, ThrowOnError>): RequestResult<PatchAppsByIdDeploymentsByDeploymentIdResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchAppsByIdDeploymentsByDeploymentIdResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/deployments/{deploymentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve a deployment
 *
 * Only a listed approver other than the requester, on the revision they reviewed
 */
export const postAppsByIdDeploymentsByDeploymentIdApprove = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdDeploymentsByDeploymentIdApproveData, ThrowOnError>): RequestResult<PostAppsByIdDeploymentsByDeploymentIdApproveResponses, PostAppsByIdDeploymentsByDeploymentIdApproveErrors, ThrowOnError> => (options.client ?? client).post<PostAppsByIdDeploymentsByDeploymentIdApproveResponses, PostAppsByIdDeploymentsByDeploymentIdApproveErrors, ThrowOnError>({
    url: '/apps/{id}/deployments/{deploymentId}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel a deployment request
 */
export const postAppsByIdDeploymentsByDeploymentIdCancel = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdDeploymentsByDeploymentIdCancelData, ThrowOnError>): RequestResult<PostAppsByIdDeploymentsByDeploymentIdCancelResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAppsByIdDeploymentsByDeploymentIdCancelResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/deployments/{deploymentId}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a deployment as deployed
 */
export const postAppsByIdDeploymentsByDeploymentIdDeploy = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdDeploymentsByDeploymentIdDeployData, ThrowOnError>): RequestResult<PostAppsByIdDeploymentsByDeploymentIdDeployResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAppsByIdDeploymentsByDeploymentIdDeployResponses, unknown, ThrowOnError>({ url: '/apps/{id}/deployments/{deploymentId}/deploy', ...options });

/**
 * Reject a deployment
 *
 * Requires a reason
 */
export const postAppsByIdDeploymentsByDeploymentIdReject = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdDeploymentsByDeploymentIdRejectData, ThrowOnError>): RequestResult<PostAppsByIdDeploymentsByDeploymentIdRejectResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAppsByIdDeploymentsByDeploymentIdRejectResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/deployments/{deploymentId}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resubmit a rejected deployment
 */
export const postAppsByIdDeploymentsByDeploymentIdResubmit = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdDeploymentsByDeploymentIdResubmitData, ThrowOnError>): RequestResult<PostAppsByIdDeploymentsByDeploymentIdResubmitResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAppsByIdDeploymentsByDeploymentIdResubmitResponses, unknown, ThrowOnError>({ url: '/apps/{id}/deployments/{deploymentId}/resubmit', ...options });

/**
 * Roll back a deployment
 *
 * Only the environment's live deployment; requires a reason
 */
export const postAppsByIdDeploymentsByDeploymentIdRollback = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdDeploymentsByDeploymentIdRollbackData, ThrowOnError>): RequestResult<PostAppsByIdDeploymentsByDeploymentIdRollbackResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAppsByIdDeploymentsByDeploymentIdRollbackResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/deployments/{deploymentId}/rollback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List environments
 *
 * An app's environments in promotion order, with approvers and the live deployment
 */
export const getAppsByIdEnvironments = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdEnvironmentsData, ThrowOnError>): RequestResult<GetAppsByIdEnvironmentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAppsByIdEnvironmentsResponses, unknown, ThrowOnError>({ url: '/apps/{id}/environments', ...options });

/**
 * Create an environment
 */
export const postAppsByIdEnvironments = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdEnvironmentsData, ThrowOnError>): RequestResult<PostAppsByIdEnvironmentsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAppsByIdEnvironmentsResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/environments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an environment
 */
export const deleteAppsByIdEnvironmentsByEnvId = <ThrowOnError extends boolean = false>(options: Options<DeleteAppsByIdEnvironmentsByEnvIdData, ThrowOnError>): RequestResult<DeleteAppsByIdEnvironmentsByEnvIdResponses, DeleteAppsByIdEnvironmentsByEnvIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAppsByIdEnvironmentsByEnvIdResponses, DeleteAppsByIdEnvironmentsByEnvIdErrors, ThrowOnError>({ url: '/apps/{id}/environments/{envId}', ...options });

/**
 * Update an environment
 *
 * position moves the environment within the promotion order
 */
export const putAppsByIdEnvironmentsByEnvId = <ThrowOnError extends boolean = false>(options: Options<PutAppsByIdEnvironmentsByEnvIdData, ThrowOnError>): RequestResult<PutAppsByIdEnvironmentsByEnvIdResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutAppsByIdEnvironmentsByEnvIdResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/environments/{envId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set an environment's approvers
 */
export const putAppsByIdEnvironmentsByEnvIdApprovers = <ThrowOnError extends boolean = false>(options: Options<PutAppsByIdEnvironmentsByEnvIdApproversData, ThrowOnError>): RequestResult<PutAppsByIdEnvironmentsByEnvIdApproversResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutAppsByIdEnvironmentsByEnvIdApproversResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/environments/{envId}/approvers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List app members
 *
 * Returns the app's members; they are the members of every project in the app
 */
export const getAppsByIdMembers = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdMembersData, ThrowOnError>): RequestResult<GetAppsByIdMembersResponses, GetAppsByIdMembersErrors, ThrowOnError> => (options.client ?? client).get<GetAppsByIdMembersResponses, GetAppsByIdMembersErrors, ThrowOnError>({ url: '/apps/{id}/members', ...options });

/**
 * Add a member to an app
 *
 * Gives a user access to every project in the app with the given role
 */
export const postAppsByIdMembers = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdMembersData, ThrowOnError>): RequestResult<PostAppsByIdMembersResponses, PostAppsByIdMembersErrors, ThrowOnError> => (options.client ?? client).post<PostAppsByIdMembersResponses, PostAppsByIdMembersErrors, ThrowOnError>({
    url: '/apps/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a member from an app
 *
 * Revokes a user's app membership (and so their access to its projects as a viewer/guest)
 */
export const deleteAppsByIdMembersByUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteAppsByIdMembersByUserIdData, ThrowOnError>): RequestResult<DeleteAppsByIdMembersByUserIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteAppsByIdMembersByUserIdResponses, unknown, ThrowOnError>({ url: '/apps/{id}/members/{userId}', ...options });

/**
 * Update a member's role in an app
 *
 * Changes the role of an existing app member
 */
export const putAppsByIdMembersByUserId = <ThrowOnError extends boolean = false>(options: Options<PutAppsByIdMembersByUserIdData, ThrowOnError>): RequestResult<PutAppsByIdMembersByUserIdResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutAppsByIdMembersByUserIdResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/members/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Caller's access within an app
 *
 * Returns the caller's role, permissions and the environments they approve
 */
export const getAppsByIdMyAccess = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdMyAccessData, ThrowOnError>): RequestResult<GetAppsByIdMyAccessResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAppsByIdMyAccessResponses, unknown, ThrowOnError>({ url: '/apps/{id}/my-access', ...options });

/**
 * Create a project inside an app
 *
 * Creates a project under the selected app while retaining all existing project defaults and behavior.
 */
export const postAppsByIdProjects = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdProjectsData, ThrowOnError>): RequestResult<PostAppsByIdProjectsResponses, PostAppsByIdProjectsErrors, ThrowOnError> => (options.client ?? client).post<PostAppsByIdProjectsResponses, PostAppsByIdProjectsErrors, ThrowOnError>({
    url: '/apps/{id}/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List releases
 *
 * Returns an app's releases with progress and per-environment status
 */
export const getAppsByIdReleases = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdReleasesData, ThrowOnError>): RequestResult<GetAppsByIdReleasesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAppsByIdReleasesResponses, unknown, ThrowOnError>({ url: '/apps/{id}/releases', ...options });

/**
 * Create a release
 */
export const postAppsByIdReleases = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdReleasesData, ThrowOnError>): RequestResult<PostAppsByIdReleasesResponses, PostAppsByIdReleasesErrors, ThrowOnError> => (options.client ?? client).post<PostAppsByIdReleasesResponses, PostAppsByIdReleasesErrors, ThrowOnError>({
    url: '/apps/{id}/releases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a release
 *
 * Only releases that were never deployed can be deleted
 */
export const deleteAppsByIdReleasesByReleaseId = <ThrowOnError extends boolean = false>(options: Options<DeleteAppsByIdReleasesByReleaseIdData, ThrowOnError>): RequestResult<DeleteAppsByIdReleasesByReleaseIdResponses, DeleteAppsByIdReleasesByReleaseIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAppsByIdReleasesByReleaseIdResponses, DeleteAppsByIdReleasesByReleaseIdErrors, ThrowOnError>({ url: '/apps/{id}/releases/{releaseId}', ...options });

/**
 * Get a release
 */
export const getAppsByIdReleasesByReleaseId = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdReleasesByReleaseIdData, ThrowOnError>): RequestResult<GetAppsByIdReleasesByReleaseIdResponses, GetAppsByIdReleasesByReleaseIdErrors, ThrowOnError> => (options.client ?? client).get<GetAppsByIdReleasesByReleaseIdResponses, GetAppsByIdReleasesByReleaseIdErrors, ThrowOnError>({ url: '/apps/{id}/releases/{releaseId}', ...options });

/**
 * Update a release
 *
 * Changes only the fields present; project_ids replaces the release's projects
 */
export const putAppsByIdReleasesByReleaseId = <ThrowOnError extends boolean = false>(options: Options<PutAppsByIdReleasesByReleaseIdData, ThrowOnError>): RequestResult<PutAppsByIdReleasesByReleaseIdResponses, PutAppsByIdReleasesByReleaseIdErrors, ThrowOnError> => (options.client ?? client).put<PutAppsByIdReleasesByReleaseIdResponses, PutAppsByIdReleasesByReleaseIdErrors, ThrowOnError>({
    url: '/apps/{id}/releases/{releaseId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Tasks that can be added to a release
 */
export const getAppsByIdReleasesByReleaseIdCandidates = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdReleasesByReleaseIdCandidatesData, ThrowOnError>): RequestResult<GetAppsByIdReleasesByReleaseIdCandidatesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAppsByIdReleasesByReleaseIdCandidatesResponses, unknown, ThrowOnError>({ url: '/apps/{id}/releases/{releaseId}/candidates', ...options });

/**
 * List a release's tasks
 */
export const getAppsByIdReleasesByReleaseIdTasks = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdReleasesByReleaseIdTasksData, ThrowOnError>): RequestResult<GetAppsByIdReleasesByReleaseIdTasksResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAppsByIdReleasesByReleaseIdTasksResponses, unknown, ThrowOnError>({ url: '/apps/{id}/releases/{releaseId}/tasks', ...options });

/**
 * Add tasks to a release
 */
export const postAppsByIdReleasesByReleaseIdTasks = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdReleasesByReleaseIdTasksData, ThrowOnError>): RequestResult<PostAppsByIdReleasesByReleaseIdTasksResponses, PostAppsByIdReleasesByReleaseIdTasksErrors, ThrowOnError> => (options.client ?? client).post<PostAppsByIdReleasesByReleaseIdTasksResponses, PostAppsByIdReleasesByReleaseIdTasksErrors, ThrowOnError>({
    url: '/apps/{id}/releases/{releaseId}/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove tasks from a release
 */
export const postAppsByIdReleasesByReleaseIdTasksRemove = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdReleasesByReleaseIdTasksRemoveData, ThrowOnError>): RequestResult<PostAppsByIdReleasesByReleaseIdTasksRemoveResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAppsByIdReleasesByReleaseIdTasksRemoveResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/releases/{releaseId}/tasks/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download an attachment
 *
 * Streams the file content for download
 */
export const getAttachmentsByAttachmentIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetAttachmentsByAttachmentIdDownloadData, ThrowOnError>): RequestResult<GetAttachmentsByAttachmentIdDownloadResponses, GetAttachmentsByAttachmentIdDownloadErrors, ThrowOnError> => (options.client ?? client).get<GetAttachmentsByAttachmentIdDownloadResponses, GetAttachmentsByAttachmentIdDownloadErrors, ThrowOnError>({ url: '/attachments/{attachmentId}/download', ...options });

/**
 * Get a signed attachment URL
 *
 * Returns a short-lived URL for the private attachment object
 */
export const getAttachmentsByAttachmentIdUrl = <ThrowOnError extends boolean = false>(options: Options<GetAttachmentsByAttachmentIdUrlData, ThrowOnError>): RequestResult<GetAttachmentsByAttachmentIdUrlResponses, GetAttachmentsByAttachmentIdUrlErrors, ThrowOnError> => (options.client ?? client).get<GetAttachmentsByAttachmentIdUrlResponses, GetAttachmentsByAttachmentIdUrlErrors, ThrowOnError>({ url: '/attachments/{attachmentId}/url', ...options });

/**
 * List audit log entries
 *
 * Returns the org's audit log (admin actions), newest first. Filter by action or actor.
 */
export const getAuditLog = <ThrowOnError extends boolean = false>(options?: Options<GetAuditLogData, ThrowOnError>): RequestResult<GetAuditLogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAuditLogResponses, unknown, ThrowOnError>({ url: '/audit-log', ...options });

/**
 * Logout
 *
 * Clears the auth cookie and invalidates the session
 */
export const postAuthLogout = <ThrowOnError extends boolean = false>(options?: Options<PostAuthLogoutData, ThrowOnError>): RequestResult<PostAuthLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthLogoutResponses, unknown, ThrowOnError>({ url: '/auth/logout', ...options });

/**
 * Request a magic sign-in link
 *
 * Emails a passwordless sign-in link. Always reports success so the response cannot reveal which addresses are registered.
 */
export const postAuthMagicLink = <ThrowOnError extends boolean = false>(options: Options<PostAuthMagicLinkData, ThrowOnError>): RequestResult<PostAuthMagicLinkResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAuthMagicLinkResponses, unknown, ThrowOnError>({
    url: '/auth/magic-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redeem a magic sign-in link
 *
 * Exchanges the one-time code from a sign-in link for a session cookie
 */
export const postAuthMagicLinkVerify = <ThrowOnError extends boolean = false>(options: Options<PostAuthMagicLinkVerifyData, ThrowOnError>): RequestResult<PostAuthMagicLinkVerifyResponses, PostAuthMagicLinkVerifyErrors, ThrowOnError> => (options.client ?? client).post<PostAuthMagicLinkVerifyResponses, PostAuthMagicLinkVerifyErrors, ThrowOnError>({
    url: '/auth/magic-link/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current user
 *
 * Returns the authenticated user's profile with org info
 */
export const getAuthMe = <ThrowOnError extends boolean = false>(options?: Options<GetAuthMeData, ThrowOnError>): RequestResult<GetAuthMeResponses, GetAuthMeErrors, ThrowOnError> => (options?.client ?? client).get<GetAuthMeResponses, GetAuthMeErrors, ThrowOnError>({ url: '/auth/me', ...options });

/**
 * List active sessions
 *
 * Returns the caller's active + recently-revoked sessions
 */
export const getAuthSessions = <ThrowOnError extends boolean = false>(options?: Options<GetAuthSessionsData, ThrowOnError>): RequestResult<GetAuthSessionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAuthSessionsResponses, unknown, ThrowOnError>({ url: '/auth/sessions', ...options });

/**
 * Revoke a session
 *
 * Revokes one of the caller's other sessions ("log out" that device). The current session cannot be revoked here; use /auth/logout.
 */
export const deleteAuthSessionsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAuthSessionsByIdData, ThrowOnError>): RequestResult<DeleteAuthSessionsByIdResponses, DeleteAuthSessionsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAuthSessionsByIdResponses, DeleteAuthSessionsByIdErrors, ThrowOnError>({ url: '/auth/sessions/{id}', ...options });

/**
 * Get user avatar
 *
 * Returns the avatar image for a user. Requires authentication.
 */
export const getAvatarsById = <ThrowOnError extends boolean = false>(options: Options<GetAvatarsByIdData, ThrowOnError>): RequestResult<GetAvatarsByIdResponses, GetAvatarsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetAvatarsByIdResponses, GetAvatarsByIdErrors, ThrowOnError>({ url: '/avatars/{id}', ...options });

/**
 * Download database backup
 *
 * Creates a VACUUM INTO snapshot of the SQLite database and streams it as a downloadable .db file.
 */
export const getBackupDownload = <ThrowOnError extends boolean = false>(options?: Options<GetBackupDownloadData, ThrowOnError>): RequestResult<GetBackupDownloadResponses, GetBackupDownloadErrors, ThrowOnError> => (options?.client ?? client).get<GetBackupDownloadResponses, GetBackupDownloadErrors, ThrowOnError>({ url: '/backup/download', ...options });

/**
 * Stage a database backup for restore
 *
 * Accepts an uploaded .db backup file, validates it, and stages it for restore. The server must be restarted to apply the restore.
 */
export const postBackupRestore = <ThrowOnError extends boolean = false>(options: Options<PostBackupRestoreData, ThrowOnError>): RequestResult<PostBackupRestoreResponses, PostBackupRestoreErrors, ThrowOnError> => (options.client ?? client).post<PostBackupRestoreResponses, PostBackupRestoreErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/backup/restore',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Cancel a staged restore
 *
 * Removes a staged restore file so it will not be applied on next restart.
 */
export const deleteBackupRestorePending = <ThrowOnError extends boolean = false>(options?: Options<DeleteBackupRestorePendingData, ThrowOnError>): RequestResult<DeleteBackupRestorePendingResponses, DeleteBackupRestorePendingErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteBackupRestorePendingResponses, DeleteBackupRestorePendingErrors, ThrowOnError>({ url: '/backup/restore/pending', ...options });

/**
 * Check for a pending staged restore
 *
 * Returns whether a staged restore file exists (awaiting server restart).
 */
export const getBackupRestorePending = <ThrowOnError extends boolean = false>(options?: Options<GetBackupRestorePendingData, ThrowOnError>): RequestResult<GetBackupRestorePendingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBackupRestorePendingResponses, unknown, ThrowOnError>({ url: '/backup/restore/pending', ...options });

/**
 * List Business Owners
 *
 * Returns the organization's Business Owners (people who can see every project's status)
 */
export const getBusinessOwners = <ThrowOnError extends boolean = false>(options?: Options<GetBusinessOwnersData, ThrowOnError>): RequestResult<GetBusinessOwnersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBusinessOwnersResponses, unknown, ThrowOnError>({ url: '/business-owners', ...options });

/**
 * List cycles
 *
 * Returns every cycle of the workspace, ordered by release then sprint. With project_id, task counts cover only that project.
 */
export const getCycles = <ThrowOnError extends boolean = false>(options?: Options<GetCyclesData, ThrowOnError>): RequestResult<GetCyclesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCyclesResponses, unknown, ThrowOnError>({ url: '/cycles', ...options });

/**
 * Create a cycle
 *
 * Creates a cycle identified by its release and sprint number (e.g. R1S2)
 */
export const postCycles = <ThrowOnError extends boolean = false>(options: Options<PostCyclesData, ThrowOnError>): RequestResult<PostCyclesResponses, PostCyclesErrors, ThrowOnError> => (options.client ?? client).post<PostCyclesResponses, PostCyclesErrors, ThrowOnError>({
    url: '/cycles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a cycle
 *
 * Permanently deletes a cycle; its tasks are left without a cycle
 */
export const deleteCyclesById = <ThrowOnError extends boolean = false>(options: Options<DeleteCyclesByIdData, ThrowOnError>): RequestResult<DeleteCyclesByIdResponses, DeleteCyclesByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCyclesByIdResponses, DeleteCyclesByIdErrors, ThrowOnError>({ url: '/cycles/{id}', ...options });

/**
 * Update a cycle
 *
 * Updates the fields present in the body
 */
export const putCyclesById = <ThrowOnError extends boolean = false>(options: Options<PutCyclesByIdData, ThrowOnError>): RequestResult<PutCyclesByIdResponses, PutCyclesByIdErrors, ThrowOnError> => (options.client ?? client).put<PutCyclesByIdResponses, PutCyclesByIdErrors, ThrowOnError>({
    url: '/cycles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate a cycle
 *
 * Makes this the workspace's active cycle (only one can be active)
 */
export const postCyclesByIdActivate = <ThrowOnError extends boolean = false>(options: Options<PostCyclesByIdActivateData, ThrowOnError>): RequestResult<PostCyclesByIdActivateResponses, PostCyclesByIdActivateErrors, ThrowOnError> => (options.client ?? client).post<PostCyclesByIdActivateResponses, PostCyclesByIdActivateErrors, ThrowOnError>({ url: '/cycles/{id}/activate', ...options });

/**
 * Complete a cycle
 *
 * Marks a cycle as completed and moves its unfinished tasks (see CompleteCycleRequest)
 */
export const postCyclesByIdComplete = <ThrowOnError extends boolean = false>(options: Options<PostCyclesByIdCompleteData, ThrowOnError>): RequestResult<PostCyclesByIdCompleteResponses, PostCyclesByIdCompleteErrors, ThrowOnError> => (options.client ?? client).post<PostCyclesByIdCompleteResponses, PostCyclesByIdCompleteErrors, ThrowOnError>({
    url: '/cycles/{id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get dashboard data
 *
 * Returns personalized dashboard sections (my tasks, due soon, activity, stats, apps, kanban) respecting user layout preferences.
 */
export const getDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardData, ThrowOnError>): RequestResult<GetDashboardResponses, GetDashboardErrors, ThrowOnError> => (options?.client ?? client).get<GetDashboardResponses, GetDashboardErrors, ThrowOnError>({ url: '/dashboard', ...options });

/**
 * Get dashboard Kanban board
 *
 * Returns the cross-app task board (Backlog/Todo/In Progress/Done) with optional assignee/app/type filters, plus the option lists for the assignee and app dropdown filters.
 */
export const getDashboardKanban = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardKanbanData, ThrowOnError>): RequestResult<GetDashboardKanbanResponses, GetDashboardKanbanErrors, ThrowOnError> => (options?.client ?? client).get<GetDashboardKanbanResponses, GetDashboardKanbanErrors, ThrowOnError>({ url: '/dashboard/kanban', ...options });

/**
 * Update dashboard layout
 *
 * Sets the visible sections and their order for the current user's dashboard.
 */
export const patchDashboardVisibility = <ThrowOnError extends boolean = false>(options: Options<PatchDashboardVisibilityData, ThrowOnError>): RequestResult<PatchDashboardVisibilityResponses, PatchDashboardVisibilityErrors, ThrowOnError> => (options.client ?? client).patch<PatchDashboardVisibilityResponses, PatchDashboardVisibilityErrors, ThrowOnError>({
    url: '/dashboard/visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Health check
 *
 * Returns service + DB health
 */
export const getHealthz = <ThrowOnError extends boolean = false>(options?: Options<GetHealthzData, ThrowOnError>): RequestResult<GetHealthzResponses, GetHealthzErrors, ThrowOnError> => (options?.client ?? client).get<GetHealthzResponses, GetHealthzErrors, ThrowOnError>({ url: '/healthz', ...options });

/**
 * List member invites
 */
export const getInvites = <ThrowOnError extends boolean = false>(options?: Options<GetInvitesData, ThrowOnError>): RequestResult<GetInvitesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInvitesResponses, unknown, ThrowOnError>({ url: '/invites', ...options });

/**
 * Create a member invite
 *
 * Creates an invite for an existing Firebase user and sends the Firebase sign-in URL through SMTP/SES.
 */
export const postInvites = <ThrowOnError extends boolean = false>(options: Options<PostInvitesData, ThrowOnError>): RequestResult<PostInvitesResponses, PostInvitesErrors, ThrowOnError> => (options.client ?? client).post<PostInvitesResponses, PostInvitesErrors, ThrowOnError>({
    url: '/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke member invite
 */
export const deleteInvitesById = <ThrowOnError extends boolean = false>(options: Options<DeleteInvitesByIdData, ThrowOnError>): RequestResult<DeleteInvitesByIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteInvitesByIdResponses, unknown, ThrowOnError>({ url: '/invites/{id}', ...options });

/**
 * Redeem member invite sign-in link
 *
 * Redeems the Firebase one-time code and atomically applies the invite membership.
 */
export const postInvitesByTokenAccept = <ThrowOnError extends boolean = false>(options: Options<PostInvitesByTokenAcceptData, ThrowOnError>): RequestResult<PostInvitesByTokenAcceptResponses, PostInvitesByTokenAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostInvitesByTokenAcceptResponses, PostInvitesByTokenAcceptErrors, ThrowOnError>({
    url: '/invites/{token}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate member invite
 */
export const getInvitesByTokenValidate = <ThrowOnError extends boolean = false>(options: Options<GetInvitesByTokenValidateData, ThrowOnError>): RequestResult<GetInvitesByTokenValidateResponses, GetInvitesByTokenValidateErrors, ThrowOnError> => (options.client ?? client).get<GetInvitesByTokenValidateResponses, GetInvitesByTokenValidateErrors, ThrowOnError>({ url: '/invites/{token}/validate', ...options });

/**
 * List labels
 *
 * Returns all labels for the caller's organization
 */
export const getLabels = <ThrowOnError extends boolean = false>(options?: Options<GetLabelsData, ThrowOnError>): RequestResult<GetLabelsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLabelsResponses, unknown, ThrowOnError>({ url: '/labels', ...options });

/**
 * Create a label
 *
 * Creates a new label in the organization
 */
export const postLabels = <ThrowOnError extends boolean = false>(options: Options<PostLabelsData, ThrowOnError>): RequestResult<PostLabelsResponses, PostLabelsErrors, ThrowOnError> => (options.client ?? client).post<PostLabelsResponses, PostLabelsErrors, ThrowOnError>({
    url: '/labels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a label
 *
 * Permanently deletes a label
 */
export const deleteLabelsById = <ThrowOnError extends boolean = false>(options: Options<DeleteLabelsByIdData, ThrowOnError>): RequestResult<DeleteLabelsByIdResponses, DeleteLabelsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLabelsByIdResponses, DeleteLabelsByIdErrors, ThrowOnError>({ url: '/labels/{id}', ...options });

/**
 * Update a label
 *
 * Updates a label's name and color
 */
export const patchLabelsById = <ThrowOnError extends boolean = false>(options: Options<PatchLabelsByIdData, ThrowOnError>): RequestResult<PatchLabelsByIdResponses, PatchLabelsByIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchLabelsByIdResponses, PatchLabelsByIdErrors, ThrowOnError>({
    url: '/labels/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search mentions
 *
 * Search users, projects, tasks, and channels for autocomplete in task comments.
 */
export const getMentionsSearch = <ThrowOnError extends boolean = false>(options: Options<GetMentionsSearchData, ThrowOnError>): RequestResult<GetMentionsSearchResponses, GetMentionsSearchErrors, ThrowOnError> => (options.client ?? client).get<GetMentionsSearchResponses, GetMentionsSearchErrors, ThrowOnError>({ url: '/mentions/search', ...options });

/**
 * List notifications
 *
 * Cursor-paginated list of notifications for the current user
 */
export const getNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsData, ThrowOnError>): RequestResult<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError>({ url: '/notifications', ...options });

/**
 * Mark all notifications as read
 *
 * Marks all unread notifications as read
 */
export const patchNotificationsReadAll = <ThrowOnError extends boolean = false>(options?: Options<PatchNotificationsReadAllData, ThrowOnError>): RequestResult<PatchNotificationsReadAllResponses, PatchNotificationsReadAllErrors, ThrowOnError> => (options?.client ?? client).patch<PatchNotificationsReadAllResponses, PatchNotificationsReadAllErrors, ThrowOnError>({ url: '/notifications/read-all', ...options });

/**
 * Get unread notification count
 *
 * Returns the number of unread notifications for the current user
 */
export const getNotificationsUnreadCount = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsUnreadCountData, ThrowOnError>): RequestResult<GetNotificationsUnreadCountResponses, GetNotificationsUnreadCountErrors, ThrowOnError> => (options?.client ?? client).get<GetNotificationsUnreadCountResponses, GetNotificationsUnreadCountErrors, ThrowOnError>({ url: '/notifications/unread-count', ...options });

/**
 * Mark notification as read
 *
 * Marks a single notification as read
 */
export const patchNotificationsByIdRead = <ThrowOnError extends boolean = false>(options: Options<PatchNotificationsByIdReadData, ThrowOnError>): RequestResult<PatchNotificationsByIdReadResponses, PatchNotificationsByIdReadErrors, ThrowOnError> => (options.client ?? client).patch<PatchNotificationsByIdReadResponses, PatchNotificationsByIdReadErrors, ThrowOnError>({ url: '/notifications/{id}/read', ...options });

/**
 * Delete organization
 *
 * Permanently deletes the organization (type-to-confirm the org name)
 */
export const deleteOrganization = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationData, ThrowOnError>): RequestResult<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError>({
    url: '/organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization
 *
 * Returns the caller's active organization
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options?: Options<GetOrganizationData, ThrowOnError>): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError> => (options?.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({ url: '/organization', ...options });

/**
 * Update organization
 *
 * Renames the organization and sets the message edit window
 */
export const patchOrganization = <ThrowOnError extends boolean = false>(options: Options<PatchOrganizationData, ThrowOnError>): RequestResult<PatchOrganizationResponses, PatchOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<PatchOrganizationResponses, PatchOrganizationErrors, ThrowOnError>({
    url: '/organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Portfolio: every project's delivery status
 *
 * Top-level task counts by status category per project (tasks in no story included). Business Owners and org owners/admins only.
 */
export const getPortfolioProjects = <ThrowOnError extends boolean = false>(options?: Options<GetPortfolioProjectsData, ThrowOnError>): RequestResult<GetPortfolioProjectsResponses, GetPortfolioProjectsErrors, ThrowOnError> => (options?.client ?? client).get<GetPortfolioProjectsResponses, GetPortfolioProjectsErrors, ThrowOnError>({ url: '/portfolio/projects', ...options });

/**
 * List projects
 *
 * Returns all projects for the user's organization. Pass archived=true to include archived projects.
 */
export const getProjects = <ThrowOnError extends boolean = false>(options?: Options<GetProjectsData, ThrowOnError>): RequestResult<GetProjectsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetProjectsResponses, unknown, ThrowOnError>({ url: '/projects', ...options });

/**
 * Get a project by slug
 *
 * Returns a single project by its slug
 */
export const getProjectsBySlugBySlug = <ThrowOnError extends boolean = false>(options: Options<GetProjectsBySlugBySlugData, ThrowOnError>): RequestResult<GetProjectsBySlugBySlugResponses, GetProjectsBySlugBySlugErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsBySlugBySlugResponses, GetProjectsBySlugBySlugErrors, ThrowOnError>({ url: '/projects/by-slug/{slug}', ...options });

/**
 * Delete a project
 *
 * Permanently deletes a project
 */
export const deleteProjectsById = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdResponses, DeleteProjectsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdResponses, DeleteProjectsByIdErrors, ThrowOnError>({ url: '/projects/{id}', ...options });

/**
 * Get a project
 *
 * Returns a single project by ID
 */
export const getProjectsById = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdData, ThrowOnError>): RequestResult<GetProjectsByIdResponses, GetProjectsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdResponses, GetProjectsByIdErrors, ThrowOnError>({ url: '/projects/{id}', ...options });

/**
 * Update a project
 *
 * Updates project fields
 */
export const putProjectsById = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdData, ThrowOnError>): RequestResult<PutProjectsByIdResponses, PutProjectsByIdErrors, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdResponses, PutProjectsByIdErrors, ThrowOnError>({
    url: '/projects/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive a project
 *
 * Marks a project as archived (hidden from default list, read-only)
 */
export const postProjectsByIdArchive = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdArchiveData, ThrowOnError>): RequestResult<PostProjectsByIdArchiveResponses, PostProjectsByIdArchiveErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdArchiveResponses, PostProjectsByIdArchiveErrors, ThrowOnError>({ url: '/projects/{id}/archive', ...options });

/**
 * List custom fields
 *
 * Returns all custom field definitions for a project
 */
export const getProjectsByIdCustomFields = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdCustomFieldsData, ThrowOnError>): RequestResult<GetProjectsByIdCustomFieldsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdCustomFieldsResponses, unknown, ThrowOnError>({ url: '/projects/{id}/custom-fields', ...options });

/**
 * Create a custom field
 */
export const postProjectsByIdCustomFields = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdCustomFieldsData, ThrowOnError>): RequestResult<PostProjectsByIdCustomFieldsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdCustomFieldsResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/custom-fields',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a custom field
 */
export const deleteProjectsByIdCustomFieldsByFieldId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdCustomFieldsByFieldIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdCustomFieldsByFieldIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdCustomFieldsByFieldIdResponses, unknown, ThrowOnError>({ url: '/projects/{id}/custom-fields/{fieldId}', ...options });

/**
 * Update a custom field
 */
export const patchProjectsByIdCustomFieldsByFieldId = <ThrowOnError extends boolean = false>(options: Options<PatchProjectsByIdCustomFieldsByFieldIdData, ThrowOnError>): RequestResult<PatchProjectsByIdCustomFieldsByFieldIdResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchProjectsByIdCustomFieldsByFieldIdResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/custom-fields/{fieldId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List project members
 *
 * Returns the members of the project's app, including email and work role.
 */
export const getProjectsByIdMembers = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdMembersData, ThrowOnError>): RequestResult<GetProjectsByIdMembersResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdMembersResponses, unknown, ThrowOnError>({ url: '/projects/{id}/members', ...options });

/**
 * Set a member's work role by email
 *
 * Resolves the organization member by email and sets developer or requirement_owner for this project.
 */
export const putProjectsByIdMembersWorkRole = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdMembersWorkRoleData, ThrowOnError>): RequestResult<PutProjectsByIdMembersWorkRoleResponses, PutProjectsByIdMembersWorkRoleErrors, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdMembersWorkRoleResponses, PutProjectsByIdMembersWorkRoleErrors, ThrowOnError>({
    url: '/projects/{id}/members/work-role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a member's work role
 *
 * Sets what the member does on the project (developer or requirement_owner). Separate from the access role.
 */
export const putProjectsByIdMembersByUserIdWorkRole = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdMembersByUserIdWorkRoleData, ThrowOnError>): RequestResult<PutProjectsByIdMembersByUserIdWorkRoleResponses, PutProjectsByIdMembersByUserIdWorkRoleErrors, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdMembersByUserIdWorkRoleResponses, PutProjectsByIdMembersByUserIdWorkRoleErrors, ThrowOnError>({
    url: '/projects/{id}/members/{userId}/work-role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the current user's project access
 *
 * Returns the authenticated user's effective role and permission
 * set for the given project. Org owner/admin/member use their org
 * role; viewer/guest use their per-project role (403 if not a member).
 */
export const getProjectsByIdMyAccess = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdMyAccessData, ThrowOnError>): RequestResult<GetProjectsByIdMyAccessResponses, GetProjectsByIdMyAccessErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdMyAccessResponses, GetProjectsByIdMyAccessErrors, ThrowOnError>({ url: '/projects/{id}/my-access', ...options });

/**
 * Releases that include a project
 */
export const getProjectsByIdReleases = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdReleasesData, ThrowOnError>): RequestResult<GetProjectsByIdReleasesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdReleasesResponses, unknown, ThrowOnError>({ url: '/projects/{id}/releases', ...options });

/**
 * List statuses
 *
 * Returns all task statuses for a project
 */
export const getProjectsByIdStatuses = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdStatusesData, ThrowOnError>): RequestResult<GetProjectsByIdStatusesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdStatusesResponses, unknown, ThrowOnError>({ url: '/projects/{id}/statuses', ...options });

/**
 * Create a status
 *
 * Creates a new task status for a project
 */
export const postProjectsByIdStatuses = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdStatusesData, ThrowOnError>): RequestResult<PostProjectsByIdStatusesResponses, PostProjectsByIdStatusesErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdStatusesResponses, PostProjectsByIdStatusesErrors, ThrowOnError>({
    url: '/projects/{id}/statuses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a status
 *
 * Permanently deletes a task status
 */
export const deleteProjectsByIdStatusesByStatusId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdStatusesByStatusIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdStatusesByStatusIdResponses, DeleteProjectsByIdStatusesByStatusIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdStatusesByStatusIdResponses, DeleteProjectsByIdStatusesByStatusIdErrors, ThrowOnError>({ url: '/projects/{id}/statuses/{statusId}', ...options });

/**
 * Update a status
 *
 * Updates a task status
 */
export const putProjectsByIdStatusesByStatusId = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdStatusesByStatusIdData, ThrowOnError>): RequestResult<PutProjectsByIdStatusesByStatusIdResponses, PutProjectsByIdStatusesByStatusIdErrors, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdStatusesByStatusIdResponses, PutProjectsByIdStatusesByStatusIdErrors, ThrowOnError>({
    url: '/projects/{id}/statuses/{statusId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List stories of a project
 *
 * Returns the project's stories with derived status, progress, test sign-off and health
 */
export const getProjectsByIdStories = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdStoriesData, ThrowOnError>): RequestResult<GetProjectsByIdStoriesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdStoriesResponses, unknown, ThrowOnError>({ url: '/projects/{id}/stories', ...options });

/**
 * Create a story
 *
 * Creates a business story; tasks are added to it afterwards
 */
export const postProjectsByIdStories = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdStoriesData, ThrowOnError>): RequestResult<PostProjectsByIdStoriesResponses, PostProjectsByIdStoriesErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdStoriesResponses, PostProjectsByIdStoriesErrors, ThrowOnError>({
    url: '/projects/{id}/stories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a story
 *
 * Deletes a story that has no tasks (move its tasks first)
 */
export const deleteProjectsByIdStoriesByStoryId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdStoriesByStoryIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdStoriesByStoryIdResponses, DeleteProjectsByIdStoriesByStoryIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdStoriesByStoryIdResponses, DeleteProjectsByIdStoriesByStoryIdErrors, ThrowOnError>({ url: '/projects/{id}/stories/{storyId}', ...options });

/**
 * Get a story
 *
 * Returns one story with its people, roll-up and top-level tasks
 */
export const getProjectsByIdStoriesByStoryId = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdStoriesByStoryIdData, ThrowOnError>): RequestResult<GetProjectsByIdStoriesByStoryIdResponses, GetProjectsByIdStoriesByStoryIdErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdStoriesByStoryIdResponses, GetProjectsByIdStoriesByStoryIdErrors, ThrowOnError>({ url: '/projects/{id}/stories/{storyId}', ...options });

/**
 * Update a story
 *
 * Partially updates a story; due_at "" clears the target date
 */
export const putProjectsByIdStoriesByStoryId = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdStoriesByStoryIdData, ThrowOnError>): RequestResult<PutProjectsByIdStoriesByStoryIdResponses, PutProjectsByIdStoriesByStoryIdErrors, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdStoriesByStoryIdResponses, PutProjectsByIdStoriesByStoryIdErrors, ThrowOnError>({
    url: '/projects/{id}/stories/{storyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List story attachments
 */
export const getProjectsByIdStoriesByStoryIdAttachments = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdStoriesByStoryIdAttachmentsData, ThrowOnError>): RequestResult<GetProjectsByIdStoriesByStoryIdAttachmentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdStoriesByStoryIdAttachmentsResponses, unknown, ThrowOnError>({ url: '/projects/{id}/stories/{storyId}/attachments', ...options });

/**
 * Upload a story attachment
 */
export const postProjectsByIdStoriesByStoryIdAttachments = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdStoriesByStoryIdAttachmentsData, ThrowOnError>): RequestResult<PostProjectsByIdStoriesByStoryIdAttachmentsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdStoriesByStoryIdAttachmentsResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/projects/{id}/stories/{storyId}/attachments',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete a story attachment
 *
 * The uploader, or anyone allowed to delete attachments, may delete it
 */
export const deleteProjectsByIdStoriesByStoryIdAttachmentsByAttachmentId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdStoriesByStoryIdAttachmentsByAttachmentIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdStoriesByStoryIdAttachmentsByAttachmentIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdStoriesByStoryIdAttachmentsByAttachmentIdResponses, unknown, ThrowOnError>({ url: '/projects/{id}/stories/{storyId}/attachments/{attachmentId}', ...options });

/**
 * Set a story's people
 *
 * Replaces the story's requirement owners and developers
 */
export const putProjectsByIdStoriesByStoryIdMembers = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdStoriesByStoryIdMembersData, ThrowOnError>): RequestResult<PutProjectsByIdStoriesByStoryIdMembersResponses, PutProjectsByIdStoriesByStoryIdMembersErrors, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdStoriesByStoryIdMembersResponses, PutProjectsByIdStoriesByStoryIdMembersErrors, ThrowOnError>({
    url: '/projects/{id}/stories/{storyId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List business test cases
 */
export const getProjectsByIdStoriesByStoryIdTestCases = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdStoriesByStoryIdTestCasesData, ThrowOnError>): RequestResult<GetProjectsByIdStoriesByStoryIdTestCasesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdStoriesByStoryIdTestCasesResponses, unknown, ThrowOnError>({ url: '/projects/{id}/stories/{storyId}/test-cases', ...options });

/**
 * Create a business test case
 */
export const postProjectsByIdStoriesByStoryIdTestCases = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdStoriesByStoryIdTestCasesData, ThrowOnError>): RequestResult<PostProjectsByIdStoriesByStoryIdTestCasesResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdStoriesByStoryIdTestCasesResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/stories/{storyId}/test-cases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a business test case
 */
export const deleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdResponses, unknown, ThrowOnError>({ url: '/projects/{id}/stories/{storyId}/test-cases/{testCaseId}', ...options });

/**
 * Update a business test case
 */
export const putProjectsByIdStoriesByStoryIdTestCasesByTestCaseId = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdData, ThrowOnError>): RequestResult<PutProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/stories/{storyId}/test-cases/{testCaseId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach a file to a test case
 */
export const postProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachments = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsData, ThrowOnError>): RequestResult<PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/projects/{id}/stories/{storyId}/test-cases/{testCaseId}/attachments',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete a test case attachment
 *
 * The uploader, or anyone allowed to delete attachments, may delete it
 */
export const deleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsByAttachmentId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsByAttachmentIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsByAttachmentIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdAttachmentsByAttachmentIdResponses, unknown, ThrowOnError>({ url: '/projects/{id}/stories/{storyId}/test-cases/{testCaseId}/attachments/{attachmentId}', ...options });

/**
 * Withdraw my confirmation
 *
 * Removes only the caller's own confirmation
 */
export const deleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmations = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsData, ThrowOnError>): RequestResult<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsResponses, unknown, ThrowOnError>({ url: '/projects/{id}/stories/{storyId}/test-cases/{testCaseId}/confirmations', ...options });

/**
 * Confirm a test case as tested
 *
 * Records the caller as a tester. Anyone who can view the project may confirm; several people can confirm the same case.
 */
export const postProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmations = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsData, ThrowOnError>): RequestResult<PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdStoriesByStoryIdTestCasesByTestCaseIdConfirmationsResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/stories/{storyId}/test-cases/{testCaseId}/confirmations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List tasks
 *
 * Returns tasks for a project, optionally filtered
 */
export const getProjectsByIdTasks = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksData, ThrowOnError>): RequestResult<GetProjectsByIdTasksResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks', ...options });

/**
 * Create a task
 *
 * Creates a new task in a project
 */
export const postProjectsByIdTasks = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksData, ThrowOnError>): RequestResult<PostProjectsByIdTasksResponses, PostProjectsByIdTasksErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksResponses, PostProjectsByIdTasksErrors, ThrowOnError>({
    url: '/projects/{id}/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk-update tasks
 *
 * Applies a partial update (status/priority/type/assignees/cycle) to many tasks in a project at once
 */
export const postProjectsByIdTasksBatch = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksBatchData, ThrowOnError>): RequestResult<PostProjectsByIdTasksBatchResponses, PostProjectsByIdTasksBatchErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksBatchResponses, PostProjectsByIdTasksBatchErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export project tasks
 *
 * Exports all tasks in a project as CSV or JSON
 */
export const getProjectsByIdTasksExport = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksExportData, ThrowOnError>): RequestResult<GetProjectsByIdTasksExportResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksExportResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/export', ...options });

/**
 * Reorder tasks
 *
 * Bulk-update positions for multiple tasks in a project
 */
export const postProjectsByIdTasksReorder = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksReorderData, ThrowOnError>): RequestResult<PostProjectsByIdTasksReorderResponses, PostProjectsByIdTasksReorderErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksReorderResponses, PostProjectsByIdTasksReorderErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a task
 *
 * Deletes a task. When the task has subtasks, mode controls their fate: block (default, returns 409), cascade (delete children), or promote (children become top-level).
 */
export const deleteProjectsByIdTasksByTaskId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdTasksByTaskIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdTasksByTaskIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdTasksByTaskIdResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}', ...options });

/**
 * Get a task
 *
 * Returns a single task by ID
 */
export const getProjectsByIdTasksByTaskId = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdResponses, GetProjectsByIdTasksByTaskIdErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdResponses, GetProjectsByIdTasksByTaskIdErrors, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}', ...options });

/**
 * Update a task
 *
 * Updates task fields
 */
export const putProjectsByIdTasksByTaskId = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdTasksByTaskIdData, ThrowOnError>): RequestResult<PutProjectsByIdTasksByTaskIdResponses, PutProjectsByIdTasksByTaskIdErrors, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdTasksByTaskIdResponses, PutProjectsByIdTasksByTaskIdErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List task activity
 *
 * Returns the activity history for a task (status, assignee, priority, due date changes)
 */
export const getProjectsByIdTasksByTaskIdActivity = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdActivityData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdActivityResponses, GetProjectsByIdTasksByTaskIdActivityErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdActivityResponses, GetProjectsByIdTasksByTaskIdActivityErrors, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/activity', ...options });

/**
 * List attachments
 *
 * Returns all attachments for a task
 */
export const getProjectsByIdTasksByTaskIdAttachments = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdAttachmentsData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdAttachmentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdAttachmentsResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/attachments', ...options });

/**
 * Upload an attachment
 *
 * Uploads a file as an attachment to a task
 */
export const postProjectsByIdTasksByTaskIdAttachments = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdAttachmentsData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdAttachmentsResponses, PostProjectsByIdTasksByTaskIdAttachmentsErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdAttachmentsResponses, PostProjectsByIdTasksByTaskIdAttachmentsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/projects/{id}/tasks/{taskId}/attachments',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete an attachment
 *
 * Permanently deletes an attachment
 */
export const deleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentIdResponses, DeleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentIdResponses, DeleteProjectsByIdTasksByTaskIdAttachmentsByAttachmentIdErrors, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/attachments/{attachmentId}', ...options });

/**
 * List task comments
 *
 * Returns comments for a task (oldest first within the loaded page). Cursor-paginated: pass `before` (the oldest loaded created_at) + `limit` to load older comments.
 */
export const getProjectsByIdTasksByTaskIdComments = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdCommentsData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdCommentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdCommentsResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/comments', ...options });

/**
 * Create a comment
 *
 * Adds a comment to a task. Supports @mentions (users, @everyone, channels, projects, tasks) and optional parent_id for threaded replies. Notifies mentioned users, task assignees, and the parent comment author.
 */
export const postProjectsByIdTasksByTaskIdComments = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdCommentsData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdCommentsResponses, PostProjectsByIdTasksByTaskIdCommentsErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdCommentsResponses, PostProjectsByIdTasksByTaskIdCommentsErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a comment
 *
 * Soft-deletes a comment. Only the comment author may delete.
 */
export const deleteProjectsByIdTasksByTaskIdCommentsByCommentId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdTasksByTaskIdCommentsByCommentIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdTasksByTaskIdCommentsByCommentIdResponses, DeleteProjectsByIdTasksByTaskIdCommentsByCommentIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdTasksByTaskIdCommentsByCommentIdResponses, DeleteProjectsByIdTasksByTaskIdCommentsByCommentIdErrors, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/comments/{commentId}', ...options });

/**
 * Update a comment
 *
 * Edits a comment's content. Only the comment author may edit. Sets the edited_at timestamp.
 */
export const patchProjectsByIdTasksByTaskIdCommentsByCommentId = <ThrowOnError extends boolean = false>(options: Options<PatchProjectsByIdTasksByTaskIdCommentsByCommentIdData, ThrowOnError>): RequestResult<PatchProjectsByIdTasksByTaskIdCommentsByCommentIdResponses, PatchProjectsByIdTasksByTaskIdCommentsByCommentIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchProjectsByIdTasksByTaskIdCommentsByCommentIdResponses, PatchProjectsByIdTasksByTaskIdCommentsByCommentIdErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/comments/{commentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get custom field values for a task
 */
export const getProjectsByIdTasksByTaskIdCustomFields = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdCustomFieldsData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdCustomFieldsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdCustomFieldsResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/custom-fields', ...options });

/**
 * Set a custom field value for a task
 */
export const putProjectsByIdTasksByTaskIdCustomFieldsByFieldId = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdTasksByTaskIdCustomFieldsByFieldIdData, ThrowOnError>): RequestResult<PutProjectsByIdTasksByTaskIdCustomFieldsByFieldIdResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdTasksByTaskIdCustomFieldsByFieldIdResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/custom-fields/{fieldId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add a blocking dependency
 *
 * Records that the task is blocked by the given blocking task
 */
export const postProjectsByIdTasksByTaskIdDependencies = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdDependenciesData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdDependenciesResponses, PostProjectsByIdTasksByTaskIdDependenciesErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdDependenciesResponses, PostProjectsByIdTasksByTaskIdDependenciesErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/dependencies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List blocked tasks
 *
 * Returns the tasks the given task is blocking (these wait on the task)
 */
export const getProjectsByIdTasksByTaskIdDependenciesBlocked = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdDependenciesBlockedData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdDependenciesBlockedResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdDependenciesBlockedResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/dependencies/blocked', ...options });

/**
 * List blocking tasks
 *
 * Returns the tasks blocking the given task (the task is blocked by these)
 */
export const getProjectsByIdTasksByTaskIdDependenciesBlocking = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdDependenciesBlockingData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdDependenciesBlockingResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdDependenciesBlockingResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/dependencies/blocking', ...options });

/**
 * Remove a blocking dependency
 *
 * Removes the blocking edge between two tasks
 */
export const deleteProjectsByIdTasksByTaskIdDependenciesByBlocksTaskId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdTasksByTaskIdDependenciesByBlocksTaskIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdTasksByTaskIdDependenciesByBlocksTaskIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdTasksByTaskIdDependenciesByBlocksTaskIdResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/dependencies/{blocksTaskId}', ...options });

/**
 * A task's release and deployments
 */
export const getProjectsByIdTasksByTaskIdDeployments = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdDeploymentsData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdDeploymentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdDeploymentsResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/deployments', ...options });

/**
 * Duplicate a task
 *
 * Creates a copy of a task in the same project + status with a fresh ID
 */
export const postProjectsByIdTasksByTaskIdDuplicate = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdDuplicateData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdDuplicateResponses, PostProjectsByIdTasksByTaskIdDuplicateErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdDuplicateResponses, PostProjectsByIdTasksByTaskIdDuplicateErrors, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/duplicate', ...options });

/**
 * Get task labels
 *
 * Returns all labels attached to a task
 */
export const getProjectsByIdTasksByTaskIdLabels = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdLabelsData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdLabelsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdLabelsResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/labels', ...options });

/**
 * Set task labels
 *
 * Replaces all labels on a task with the given set
 */
export const putProjectsByIdTasksByTaskIdLabels = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdTasksByTaskIdLabelsData, ThrowOnError>): RequestResult<PutProjectsByIdTasksByTaskIdLabelsResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdTasksByTaskIdLabelsResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/labels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move a task to another project
 *
 * Re-homes a task into a different project + status (clears cycle + parent)
 */
export const postProjectsByIdTasksByTaskIdMove = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdMoveData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdMoveResponses, PostProjectsByIdTasksByTaskIdMoveErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdMoveResponses, PostProjectsByIdTasksByTaskIdMoveErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move a task
 *
 * Changes task status and position
 */
export const patchProjectsByIdTasksByTaskIdPosition = <ThrowOnError extends boolean = false>(options: Options<PatchProjectsByIdTasksByTaskIdPositionData, ThrowOnError>): RequestResult<PatchProjectsByIdTasksByTaskIdPositionResponses, PatchProjectsByIdTasksByTaskIdPositionErrors, ThrowOnError> => (options.client ?? client).patch<PatchProjectsByIdTasksByTaskIdPositionResponses, PatchProjectsByIdTasksByTaskIdPositionErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/position',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a task's release
 *
 * Links the task to an open release that includes its project; null unlinks
 */
export const putProjectsByIdTasksByTaskIdRelease = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdTasksByTaskIdReleaseData, ThrowOnError>): RequestResult<PutProjectsByIdTasksByTaskIdReleaseResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdTasksByTaskIdReleaseResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List subtasks
 *
 * Returns the direct children (subtasks) of a task
 */
export const getProjectsByIdTasksByTaskIdSubtasks = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdSubtasksData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdSubtasksResponses, GetProjectsByIdTasksByTaskIdSubtasksErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdSubtasksResponses, GetProjectsByIdTasksByTaskIdSubtasksErrors, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/subtasks', ...options });

/**
 * Reorder subtasks
 *
 * Re-orders a task's direct children by updating their subtask_position keys
 */
export const postProjectsByIdTasksByTaskIdSubtasksReorder = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdSubtasksReorderData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdSubtasksReorderResponses, PostProjectsByIdTasksByTaskIdSubtasksReorderErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdSubtasksReorderResponses, PostProjectsByIdTasksByTaskIdSubtasksReorderErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/subtasks/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List time entries
 *
 * Returns all time entries for a task
 */
export const getProjectsByIdTasksByTaskIdTimeEntries = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTasksByTaskIdTimeEntriesData, ThrowOnError>): RequestResult<GetProjectsByIdTasksByTaskIdTimeEntriesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTasksByTaskIdTimeEntriesResponses, unknown, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/time-entries', ...options });

/**
 * Create a manual time entry
 *
 * Creates a completed time entry with a specified duration
 */
export const postProjectsByIdTasksByTaskIdTimeEntries = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdTimeEntriesData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdTimeEntriesResponses, PostProjectsByIdTasksByTaskIdTimeEntriesErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdTimeEntriesResponses, PostProjectsByIdTasksByTaskIdTimeEntriesErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/time-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a timer
 *
 * Starts a running time entry for the current user on a task
 */
export const postProjectsByIdTasksByTaskIdTimeEntriesStart = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdTimeEntriesStartData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdTimeEntriesStartResponses, PostProjectsByIdTasksByTaskIdTimeEntriesStartErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdTimeEntriesStartResponses, PostProjectsByIdTasksByTaskIdTimeEntriesStartErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/time-entries/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop the active timer
 *
 * Stops the current user's running timer on a task
 */
export const postProjectsByIdTasksByTaskIdTimeEntriesStop = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTasksByTaskIdTimeEntriesStopData, ThrowOnError>): RequestResult<PostProjectsByIdTasksByTaskIdTimeEntriesStopResponses, PostProjectsByIdTasksByTaskIdTimeEntriesStopErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTasksByTaskIdTimeEntriesStopResponses, PostProjectsByIdTasksByTaskIdTimeEntriesStopErrors, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/time-entries/stop', ...options });

/**
 * Delete a time entry
 *
 * Permanently deletes a time entry
 */
export const deleteProjectsByIdTasksByTaskIdTimeEntriesByEntryId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdTasksByTaskIdTimeEntriesByEntryIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdTasksByTaskIdTimeEntriesByEntryIdResponses, DeleteProjectsByIdTasksByTaskIdTimeEntriesByEntryIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdTasksByTaskIdTimeEntriesByEntryIdResponses, DeleteProjectsByIdTasksByTaskIdTimeEntriesByEntryIdErrors, ThrowOnError>({ url: '/projects/{id}/tasks/{taskId}/time-entries/{entryId}', ...options });

/**
 * Update a time entry
 *
 * Updates a time entry's description and/or duration
 */
export const putProjectsByIdTasksByTaskIdTimeEntriesByEntryId = <ThrowOnError extends boolean = false>(options: Options<PutProjectsByIdTasksByTaskIdTimeEntriesByEntryIdData, ThrowOnError>): RequestResult<PutProjectsByIdTasksByTaskIdTimeEntriesByEntryIdResponses, PutProjectsByIdTasksByTaskIdTimeEntriesByEntryIdErrors, ThrowOnError> => (options.client ?? client).put<PutProjectsByIdTasksByTaskIdTimeEntriesByEntryIdResponses, PutProjectsByIdTasksByTaskIdTimeEntriesByEntryIdErrors, ThrowOnError>({
    url: '/projects/{id}/tasks/{taskId}/time-entries/{entryId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List task templates
 *
 * Returns all task templates for a project
 */
export const getProjectsByIdTemplates = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTemplatesData, ThrowOnError>): RequestResult<GetProjectsByIdTemplatesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTemplatesResponses, unknown, ThrowOnError>({ url: '/projects/{id}/templates', ...options });

/**
 * Create a task template
 *
 * Creates a new task template with optional recurrence
 */
export const postProjectsByIdTemplates = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTemplatesData, ThrowOnError>): RequestResult<PostProjectsByIdTemplatesResponses, PostProjectsByIdTemplatesErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTemplatesResponses, PostProjectsByIdTemplatesErrors, ThrowOnError>({
    url: '/projects/{id}/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a task template
 */
export const deleteProjectsByIdTemplatesByTemplateId = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectsByIdTemplatesByTemplateIdData, ThrowOnError>): RequestResult<DeleteProjectsByIdTemplatesByTemplateIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectsByIdTemplatesByTemplateIdResponses, unknown, ThrowOnError>({ url: '/projects/{id}/templates/{templateId}', ...options });

/**
 * Update a task template
 */
export const patchProjectsByIdTemplatesByTemplateId = <ThrowOnError extends boolean = false>(options: Options<PatchProjectsByIdTemplatesByTemplateIdData, ThrowOnError>): RequestResult<PatchProjectsByIdTemplatesByTemplateIdResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchProjectsByIdTemplatesByTemplateIdResponses, unknown, ThrowOnError>({
    url: '/projects/{id}/templates/{templateId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Instantiate a task from a template
 *
 * Creates a real task from a template. For recurring templates, advances next_run_at.
 */
export const postProjectsByIdTemplatesByTemplateIdInstantiate = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdTemplatesByTemplateIdInstantiateData, ThrowOnError>): RequestResult<PostProjectsByIdTemplatesByTemplateIdInstantiateResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdTemplatesByTemplateIdInstantiateResponses, unknown, ThrowOnError>({ url: '/projects/{id}/templates/{templateId}/instantiate', ...options });

/**
 * Export time entries
 *
 * Exports time entries for a project's tasks as CSV or JSON
 */
export const getProjectsByIdTimeEntriesExport = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByIdTimeEntriesExportData, ThrowOnError>): RequestResult<GetProjectsByIdTimeEntriesExportResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProjectsByIdTimeEntriesExportResponses, unknown, ThrowOnError>({ url: '/projects/{id}/time-entries/export', ...options });

/**
 * Unarchive a project
 *
 * Restores an archived project to the active list
 */
export const postProjectsByIdUnarchive = <ThrowOnError extends boolean = false>(options: Options<PostProjectsByIdUnarchiveData, ThrowOnError>): RequestResult<PostProjectsByIdUnarchiveResponses, PostProjectsByIdUnarchiveErrors, ThrowOnError> => (options.client ?? client).post<PostProjectsByIdUnarchiveResponses, PostProjectsByIdUnarchiveErrors, ThrowOnError>({ url: '/projects/{id}/unarchive', ...options });

/**
 * Unsubscribe from push notifications
 *
 * Removes a Web Push subscription endpoint for the current user
 */
export const deletePushSubscribe = <ThrowOnError extends boolean = false>(options: Options<DeletePushSubscribeData, ThrowOnError>): RequestResult<DeletePushSubscribeResponses, DeletePushSubscribeErrors, ThrowOnError> => (options.client ?? client).delete<DeletePushSubscribeResponses, DeletePushSubscribeErrors, ThrowOnError>({
    url: '/push/subscribe',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Subscribe to push notifications
 *
 * Registers a Web Push subscription endpoint for the current user
 */
export const postPushSubscribe = <ThrowOnError extends boolean = false>(options: Options<PostPushSubscribeData, ThrowOnError>): RequestResult<PostPushSubscribeResponses, PostPushSubscribeErrors, ThrowOnError> => (options.client ?? client).post<PostPushSubscribeResponses, PostPushSubscribeErrors, ThrowOnError>({
    url: '/push/subscribe',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get push public key
 *
 * Returns the VAPID public key for browser push subscription
 */
export const getPushVapidPublicKey = <ThrowOnError extends boolean = false>(options?: Options<GetPushVapidPublicKeyData, ThrowOnError>): RequestResult<GetPushVapidPublicKeyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPushVapidPublicKeyResponses, unknown, ThrowOnError>({ url: '/push/vapid-public-key', ...options });

/**
 * Global search
 *
 * Search across projects, tasks, channels, DMs, and members. Empty q returns recent projects/tasks.
 */
export const getSearch = <ThrowOnError extends boolean = false>(options?: Options<GetSearchData, ThrowOnError>): RequestResult<GetSearchResponses, GetSearchErrors, ThrowOnError> => (options?.client ?? client).get<GetSearchResponses, GetSearchErrors, ThrowOnError>({ url: '/search', ...options });

/**
 * Get notification preferences
 *
 * Returns the current user's notification preferences
 */
export const getSettingsNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsNotificationsData, ThrowOnError>): RequestResult<GetSettingsNotificationsResponses, GetSettingsNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<GetSettingsNotificationsResponses, GetSettingsNotificationsErrors, ThrowOnError>({ url: '/settings/notifications', ...options });

/**
 * Set notification preference
 *
 * Toggle a notification type preference
 */
export const patchSettingsNotificationsByType = <ThrowOnError extends boolean = false>(options: Options<PatchSettingsNotificationsByTypeData, ThrowOnError>): RequestResult<PatchSettingsNotificationsByTypeResponses, PatchSettingsNotificationsByTypeErrors, ThrowOnError> => (options.client ?? client).patch<PatchSettingsNotificationsByTypeResponses, PatchSettingsNotificationsByTypeErrors, ThrowOnError>({
    url: '/settings/notifications/{type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user preferences
 *
 * Returns the current user's account preferences
 */
export const getSettingsPreferences = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsPreferencesData, ThrowOnError>): RequestResult<GetSettingsPreferencesResponses, GetSettingsPreferencesErrors, ThrowOnError> => (options?.client ?? client).get<GetSettingsPreferencesResponses, GetSettingsPreferencesErrors, ThrowOnError>({ url: '/settings/preferences', ...options });

/**
 * Update user preferences
 *
 * Partially updates the current user's account preferences
 */
export const patchSettingsPreferences = <ThrowOnError extends boolean = false>(options: Options<PatchSettingsPreferencesData, ThrowOnError>): RequestResult<PatchSettingsPreferencesResponses, PatchSettingsPreferencesErrors, ThrowOnError> => (options.client ?? client).patch<PatchSettingsPreferencesResponses, PatchSettingsPreferencesErrors, ThrowOnError>({
    url: '/settings/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check setup status
 *
 * Returns whether the initial organization has been created
 */
export const getSetup = <ThrowOnError extends boolean = false>(options?: Options<GetSetupData, ThrowOnError>): RequestResult<GetSetupResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSetupResponses, unknown, ThrowOnError>({ url: '/setup', ...options });

/**
 * Sprint dashboard context
 *
 * Sprints (newest first), the active sprint, and the projects and people the caller can filter by.
 */
export const getSprintDashboardContext = <ThrowOnError extends boolean = false>(options?: Options<GetSprintDashboardContextData, ThrowOnError>): RequestResult<GetSprintDashboardContextResponses, GetSprintDashboardContextErrors, ThrowOnError> => (options?.client ?? client).get<GetSprintDashboardContextResponses, GetSprintDashboardContextErrors, ThrowOnError>({ url: '/sprint-dashboard/context', ...options });

/**
 * Sprint dashboard: my work
 *
 * The caller's sprint progress, due dates, running timer, up-next list and recent completions. assignee_id is ignored.
 */
export const getSprintDashboardMe = <ThrowOnError extends boolean = false>(options?: Options<GetSprintDashboardMeData, ThrowOnError>): RequestResult<GetSprintDashboardMeResponses, GetSprintDashboardMeErrors, ThrowOnError> => (options?.client ?? client).get<GetSprintDashboardMeResponses, GetSprintDashboardMeErrors, ThrowOnError>({ url: '/sprint-dashboard/me', ...options });

/**
 * Sprint dashboard overview
 *
 * Sprint scope, health, burndown, release progress, criticality, per-project status and what needs attention.
 */
export const getSprintDashboardOverview = <ThrowOnError extends boolean = false>(options?: Options<GetSprintDashboardOverviewData, ThrowOnError>): RequestResult<GetSprintDashboardOverviewResponses, GetSprintDashboardOverviewErrors, ThrowOnError> => (options?.client ?? client).get<GetSprintDashboardOverviewResponses, GetSprintDashboardOverviewErrors, ThrowOnError>({ url: '/sprint-dashboard/overview', ...options });

/**
 * Sprint dashboard projects and apps
 *
 * Backlog, planned, sprint stages and open requirements/issues per project, rolled up per app.
 */
export const getSprintDashboardProjects = <ThrowOnError extends boolean = false>(options?: Options<GetSprintDashboardProjectsData, ThrowOnError>): RequestResult<GetSprintDashboardProjectsResponses, GetSprintDashboardProjectsErrors, ThrowOnError> => (options?.client ?? client).get<GetSprintDashboardProjectsResponses, GetSprintDashboardProjectsErrors, ThrowOnError>({ url: '/sprint-dashboard/projects', ...options });

/**
 * Sprint dashboard requirements and issues
 *
 * Open requirements and issues by priority, issues per project, the weekly opened/resolved trend and the oldest urgent/high issues.
 */
export const getSprintDashboardQuality = <ThrowOnError extends boolean = false>(options?: Options<GetSprintDashboardQualityData, ThrowOnError>): RequestResult<GetSprintDashboardQualityResponses, GetSprintDashboardQualityErrors, ThrowOnError> => (options?.client ?? client).get<GetSprintDashboardQualityResponses, GetSprintDashboardQualityErrors, ThrowOnError>({ url: '/sprint-dashboard/quality', ...options });

/**
 * Sprint dashboard team
 *
 * Who is working on what: each person's sprint work, current task, logged time and flags.
 */
export const getSprintDashboardTeam = <ThrowOnError extends boolean = false>(options?: Options<GetSprintDashboardTeamData, ThrowOnError>): RequestResult<GetSprintDashboardTeamResponses, GetSprintDashboardTeamErrors, ThrowOnError> => (options?.client ?? client).get<GetSprintDashboardTeamResponses, GetSprintDashboardTeamErrors, ThrowOnError>({ url: '/sprint-dashboard/team', ...options });

/**
 * List stories across projects
 *
 * scope=mine: stories I work on or own, with their tasks embedded. scope=all: every story (Business Owners and org admins only), without tasks.
 */
export const getStories = <ThrowOnError extends boolean = false>(options?: Options<GetStoriesData, ThrowOnError>): RequestResult<GetStoriesResponses, GetStoriesErrors, ThrowOnError> => (options?.client ?? client).get<GetStoriesResponses, GetStoriesErrors, ThrowOnError>({ url: '/stories', ...options });

/**
 * Download a story attachment
 */
export const getStoryAttachmentsByAttachmentIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetStoryAttachmentsByAttachmentIdDownloadData, ThrowOnError>): RequestResult<GetStoryAttachmentsByAttachmentIdDownloadResponses, GetStoryAttachmentsByAttachmentIdDownloadErrors, ThrowOnError> => (options.client ?? client).get<GetStoryAttachmentsByAttachmentIdDownloadResponses, GetStoryAttachmentsByAttachmentIdDownloadErrors, ThrowOnError>({ url: '/story-attachments/{attachmentId}/download', ...options });

/**
 * Returns tasks assigned to the current user across all projects, with filtering, searching, and status/project info.
 */
export const getTasks = <ThrowOnError extends boolean = false>(options?: Options<GetTasksData, ThrowOnError>): RequestResult<GetTasksResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTasksResponses, unknown, ThrowOnError>({ url: '/tasks', ...options });

/**
 * Download a test case attachment
 */
export const getTestCaseAttachmentsByAttachmentIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetTestCaseAttachmentsByAttachmentIdDownloadData, ThrowOnError>): RequestResult<GetTestCaseAttachmentsByAttachmentIdDownloadResponses, GetTestCaseAttachmentsByAttachmentIdDownloadErrors, ThrowOnError> => (options.client ?? client).get<GetTestCaseAttachmentsByAttachmentIdDownloadResponses, GetTestCaseAttachmentsByAttachmentIdDownloadErrors, ThrowOnError>({ url: '/test-case-attachments/{attachmentId}/download', ...options });

/**
 * List users
 *
 * Returns paginated users in the organization, optionally filtered by search, role, and active status
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>): RequestResult<GetUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUsersResponses, unknown, ThrowOnError>({ url: '/users', ...options });

/**
 * Get user
 *
 * Returns a single user by ID
 */
export const getUsersById = <ThrowOnError extends boolean = false>(options: Options<GetUsersByIdData, ThrowOnError>): RequestResult<GetUsersByIdResponses, GetUsersByIdErrors, ThrowOnError> => (options.client ?? client).get<GetUsersByIdResponses, GetUsersByIdErrors, ThrowOnError>({ url: '/users/{id}', ...options });

/**
 * Update user active status
 *
 * Activates or deactivates a user account
 */
export const putUsersByIdActive = <ThrowOnError extends boolean = false>(options: Options<PutUsersByIdActiveData, ThrowOnError>): RequestResult<PutUsersByIdActiveResponses, PutUsersByIdActiveErrors, ThrowOnError> => (options.client ?? client).put<PutUsersByIdActiveResponses, PutUsersByIdActiveErrors, ThrowOnError>({
    url: '/users/{id}/active',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List user's app memberships
 *
 * Returns every app the user is a member of (and so every project in those apps)
 */
export const getUsersByIdAppMemberships = <ThrowOnError extends boolean = false>(options: Options<GetUsersByIdAppMembershipsData, ThrowOnError>): RequestResult<GetUsersByIdAppMembershipsResponses, GetUsersByIdAppMembershipsErrors, ThrowOnError> => (options.client ?? client).get<GetUsersByIdAppMembershipsResponses, GetUsersByIdAppMembershipsErrors, ThrowOnError>({ url: '/users/{id}/app-memberships', ...options });

/**
 * Update user's app memberships
 *
 * Batch-set which apps a user belongs to and their role in each
 */
export const putUsersByIdAppMemberships = <ThrowOnError extends boolean = false>(options: Options<PutUsersByIdAppMembershipsData, ThrowOnError>): RequestResult<PutUsersByIdAppMembershipsResponses, PutUsersByIdAppMembershipsErrors, ThrowOnError> => (options.client ?? client).put<PutUsersByIdAppMembershipsResponses, PutUsersByIdAppMembershipsErrors, ThrowOnError>({
    url: '/users/{id}/app-memberships',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Business Owner
 *
 * Grants or revokes the org-wide Business Owner role
 */
export const putUsersByIdBusinessOwner = <ThrowOnError extends boolean = false>(options: Options<PutUsersByIdBusinessOwnerData, ThrowOnError>): RequestResult<PutUsersByIdBusinessOwnerResponses, PutUsersByIdBusinessOwnerErrors, ThrowOnError> => (options.client ?? client).put<PutUsersByIdBusinessOwnerResponses, PutUsersByIdBusinessOwnerErrors, ThrowOnError>({
    url: '/users/{id}/business-owner',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update user role
 *
 * Changes the organization role of a user
 */
export const putUsersByIdRole = <ThrowOnError extends boolean = false>(options: Options<PutUsersByIdRoleData, ThrowOnError>): RequestResult<PutUsersByIdRoleResponses, PutUsersByIdRoleErrors, ThrowOnError> => (options.client ?? client).put<PutUsersByIdRoleResponses, PutUsersByIdRoleErrors, ThrowOnError>({
    url: '/users/{id}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List workspaces
 *
 * Returns the workspaces (organizations) the caller belongs to
 */
export const getWorkspaces = <ThrowOnError extends boolean = false>(options?: Options<GetWorkspacesData, ThrowOnError>): RequestResult<GetWorkspacesResponses, GetWorkspacesErrors, ThrowOnError> => (options?.client ?? client).get<GetWorkspacesResponses, GetWorkspacesErrors, ThrowOnError>({ url: '/workspaces', ...options });

/**
 * Create a workspace
 *
 * Creates a new organization with the caller as owner
 */
export const postWorkspaces = <ThrowOnError extends boolean = false>(options: Options<PostWorkspacesData, ThrowOnError>): RequestResult<PostWorkspacesResponses, PostWorkspacesErrors, ThrowOnError> => (options.client ?? client).post<PostWorkspacesResponses, PostWorkspacesErrors, ThrowOnError>({
    url: '/workspaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Switch active workspace
 *
 * Switches the caller's active workspace, issuing a new session cookie
 */
export const postWorkspacesByIdSwitch = <ThrowOnError extends boolean = false>(options: Options<PostWorkspacesByIdSwitchData, ThrowOnError>): RequestResult<PostWorkspacesByIdSwitchResponses, PostWorkspacesByIdSwitchErrors, ThrowOnError> => (options.client ?? client).post<PostWorkspacesByIdSwitchResponses, PostWorkspacesByIdSwitchErrors, ThrowOnError>({ url: '/workspaces/{id}/switch', ...options });

/**
 * Upgrade to WebSocket
 *
 * Upgrades the HTTP connection to a WebSocket for real-time events (chat, presence, typing, task updates).
 */
export const getWs = <ThrowOnError extends boolean = false>(options?: Options<GetWsData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/ws', ...options });
